import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { I18N } from 'commons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import v from 'scss/v';

const Alert = ({ type, message, classNames, ...props }) => {
  if (!type) type = 'success'
  const alertType = (type) => {
    switch (type) {
      case "success":
        return {
          icon: faCheckCircle,
          color: v('$green-7'),
          title: 'home.alert.box.title.success'
        }
      case "info":
        return {
          icon: faInfoCircle,
          color: v('$blue-7'),
          title: 'home.alert.box.title.info'
        }
      case "warning": 
        return {
          icon: faExclamationTriangle,
          color: v('$gold-8'),
          title: 'home.alert.box.title.warning'
        }
      case 'danger': 
        return {
          icon: faExclamationCircle,
          color: v('$red-7'),
          title: 'home.alert.box.title.error'
        }
      default:
        return {
          icon: faCheckCircle,
          color: v('$green-7'),
          title: 'home.alert.box.title.success'
        }
    }
  }
  const alert = alertType(type)
  console.log(alert)

  return (
    <div className={`alert alert-${type} ${classNames? classNames:''}`} {...props}>
      <FontAwesomeIcon icon={alert.icon} color={alert.color} width="1em" height="1em"/>
      <div className='ml-2'>
        <b><I18N>{alert.title}</I18N></b>
        <p className='mb-0'><I18N>{message}</I18N></p>
      </div>
    </div>
  )
}

Alert.propTypes = {}

export default Alert
